import {Component, Input, OnInit} from '@angular/core';
import {AuthService} from "@app/core/services/auth.service";
import {Router} from "@angular/router";

@Component({
  selector: 'app-store-created',
  templateUrl: './store-created.component.html',
  styleUrls: ['./store-created.component.scss']
})
export class StoreCreatedComponent implements OnInit {
  @Input() token: any;


  constructor(public authService: AuthService, public router: Router) {
  }

  ngOnInit(): void {
  }

  public goToStore(): void {
    this.authService.bootstrapStoreSessionFromInvitationToken(this.token);
    void this.router.navigate(['/dashboard']);
  }
}
